import { ArrowUp, SkipForward, Trash2, ListMusic } from "lucide-react";
import { fmt } from "@/lib/api";

export default function QueueList({ player, act }) {
  const q = player?.queue || [];
  return (
    <div data-testid="queue-list">
      <div className="flex items-center justify-between mb-3">
        <div className="caption">Kolejka · {q.length} · {fmt(player?.queue_length_ms || 0)}</div>
        {q.length > 0 && (
          <button onClick={() => act("control", "clear")} data-testid="clear-queue-button"
            className="text-xs font-mono text-red-300 hover:text-red-200 transition-colors">wyczyść</button>
        )}
      </div>
      {q.length === 0 ? (
        <div className="rounded-lg border border-dashed border-slate-800 p-8 text-center text-sm text-slate-500" data-testid="queue-empty">
          <ListMusic className="h-6 w-6 mx-auto mb-2 text-slate-600" />
          Kolejka jest pusta
        </div>
      ) : (
        <ol className="space-y-1 max-h-[340px] overflow-y-auto pr-1">
          {q.map((t, i) => (
            <li key={t.identifier + i} className="group flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-slate-800/50 transition-colors" data-testid={`queue-item-${i + 1}`}>
              <span className="w-6 text-right font-mono text-xs text-slate-500">{i + 1}</span>
              {t.artwork ? <img src={t.artwork} alt="" className="h-9 w-9 rounded object-cover" /> : <div className="h-9 w-9 rounded bg-slate-800" />}
              <div className="min-w-0 flex-1">
                <div className="text-sm truncate">{t.title}</div>
                <div className="text-xs text-slate-500 truncate">{t.author} · {fmt(t.length)}{t.requester ? ` · ${t.requester}` : ""}</div>
              </div>
              <div className="flex gap-1 opacity-60 group-hover:opacity-100 transition-opacity">
                {i > 0 && (
                  <button title="Na górę" onClick={() => act("move", i + 1, 1)} data-testid={`queue-item-move-top-${i + 1}`}
                    className="h-7 w-7 grid place-items-center rounded hover:bg-slate-700"><ArrowUp className="h-3.5 w-3.5" /></button>
                )}
                <button title="Przeskocz" onClick={() => act("skipto", i + 1)} data-testid={`queue-item-skipto-${i + 1}`}
                  className="h-7 w-7 grid place-items-center rounded hover:bg-slate-700"><SkipForward className="h-3.5 w-3.5" /></button>
                <button title="Usuń" onClick={() => act("remove", i + 1)} data-testid={`queue-item-remove-${i + 1}`}
                  className="h-7 w-7 grid place-items-center rounded hover:bg-red-500/20 text-red-300"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
